<div class="min-h-screen bg-gray-50 dark:bg-gray-900 pb-20">
  <div class="max-w-3xl mx-auto px-4 pt-3 pb-4">

    <!-- Alerta sem contexto -->
    <div
      *ngIf="semContexto"
      class="mb-4 rounded-xl border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/20 p-4 text-sm text-amber-900 dark:text-amber-200">
      Selecione um contexto para visualizar os planejamentos de aula.
    </div>

    <ng-container *ngIf="!semContexto">

      <!-- Título e Filtros: ocultados quando há bloqueio (sem calendário / sem período avaliativo) -->
      <ng-container *ngIf="!semCalendario && !semPeriodoAvaliativo">

        <!-- Cabeçalho: título + seletor de período avaliativo -->
        <section class="mb-3 px-1">
          <div class="flex flex-row items-center gap-2">
            <div [ngClass]="periodos.length ? 'min-w-0 basis-[42%]' : 'min-w-0 flex-1'">
              <app-page-title title="Planejamentos de aula"></app-page-title>
            </div>
            <!-- Seletor de Período Avaliativo -->
            <div class="min-w-0 basis-[58%]" *ngIf="periodos.length">
              <app-periodo-select
                [options]="periodoOptions"
                [selectedId]="periodoSelecionadoId"
                [emptyLabel]="'Período'"
                [dropdownWidthClass]="'w-full min-w-[16rem]'"
                (optionSelected)="onPeriodoOptionSelected($event)">
              </app-periodo-select>
            </div>
          </div>
        </section>

        <!-- Filtros de busca lado a lado -->
        <section class="mb-4 px-1">
          <div class="filter-row">

            <!-- Input de busca por texto -->
            <div class="custom-search-wrapper">
              <input
                type="text"
                [(ngModel)]="termoFiltro"
                (ngModelChange)="onFiltroChange()"
                placeholder="Buscar planejamento"
                class="custom-search-input">
              <div class="custom-search-icon">
                <lucide-icon name="search" class="w-4 h-4"></lucide-icon>
              </div>
            </div>

            <!-- Input de busca por data -->
            <app-datepicker
              variant="inline"
              [dataSelecionada]="filtroDataSelecionada"
              dateConstraintMode="all"
              [showClearIcon]="true"
              [showActions]="false"
              placeholder="Buscar por data"
              (dateChange)="onFiltroDataChange($event)">
            </app-datepicker>

          </div>

          <!-- Filtro de Situação -->
          <div class="mt-2.5 flex items-center gap-2">
            <app-situacao-filter-dropdown
              [opcoes]="opcoesSituacao"
              [valorSelecionado]="filtroSituacao"
              placeholder="Situação"
              (valorChange)="onSituacaoChange($event)">
            </app-situacao-filter-dropdown>
          </div>

        </section>

      </ng-container><!-- /!semCalendario && !semPeriodoAvaliativo -->

      <!-- Lista de planejamentos -->
      <app-planejamento-aula-list
        [registros]="registros"
        [carregando]="carregando"
        [semCalendario]="semCalendario"
        [semPeriodoAvaliativo]="semPeriodoAvaliativo"
        (visualizar)="visualizarRegistro($event)">
      </app-planejamento-aula-list>

      <!-- Botão Load More(Mais Resultados) -->
      <button
        *ngIf="temMaisResultados && !carregando"
        type="button"
        [disabled]="carregandoMais"
        (click)="carregarMaisResultados()"
        class="w-full mt-4 py-3 flex items-center justify-center gap-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 text-sm font-semibold tracking-wide uppercase rounded-md hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
        <lucide-icon
          *ngIf="carregandoMais"
          name="loader-circle"
          class="w-4 h-4 animate-spin">
        </lucide-icon>
        <span>{{ carregandoMais ? 'Carregando...' : 'Mais resultados' }}</span>
      </button>

    </ng-container>
  </div>
</div>

<!-- Modal de detalhamento do planejamento -->
<app-planejamento-aula-detail
  [aberta]="modalDetalheAberta"
  [registro]="registroVisualizado"
  [turmaNome]="turmaNome"
  (fechar)="fecharModalDetalhe()">
</app-planejamento-aula-detail>

